module.exports = __webpack_public_path__ + "img/icon-3.9f7c9ace.png";